import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type AlertDialogProps = {
  cancelBtnText?: string;
  confirmBtnText?: string;
  onConfirmClick?: () => void;
  onCancelClick?: () => void;
  title: string;
  message: string;
  showAlert?: boolean;
};
const AlertDialog: React.FC<AlertDialogProps> = ({
  cancelBtnText,
  confirmBtnText,
  onCancelClick,
  onConfirmClick,
  title,
  message,
  showAlert,
}) => {
  const [open, setOpen] = React.useState(showAlert);

  React.useEffect(() => {
    setOpen(showAlert);
  }, [showAlert]);

  const handleClose = () => {
    setOpen(false);
    onCancelClick && onCancelClick();
  };
  const handleConfirm = () => {
    setOpen(false);
    onConfirmClick && onConfirmClick();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open || false}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelBtnText || ''}</Button>
          <Button onClick={handleConfirm} autoFocus>
            {confirmBtnText || ''}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default AlertDialog;
